import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import React from 'react';
import { Button } from 'react-bootstrap';
import { FiChevronDown, FiChevronUp, FiInfo } from 'react-icons/fi';
import { LinkContainer } from 'react-router-bootstrap';
import { compose, withStateHandlers } from 'recompose';
import { dateFormats } from '../../../../../constants';
import { GeneralTable } from '../../../../components';
import Tooltip from '../../../../components/tooltip';

const columns = [
  {
    key: 'options',
    name: ''
  },
  {
    key: 'cpdPeriod',
    name: 'CPD Period'
  },
  {
    key: 'date',
    name: 'Snapshot Date'
  },
  {
    key: 'report',
    name: <Tooltip
      placement='bottom'
      component={
        <span className='flexbox align-center'>Progress Report for CPD period <FiInfo className='icon-green left-gap' size={16} /></span>
      } tip={<p className='padding-thin tip'>{'View a snapshot of your CPD progress for the training plan set during your CPD period'}</p>}
    />
  }
]

export const UserSnapshotTable = compose(
  withStateHandlers(
    {
      expandedRows: []
    },
    {
      toggleRow: ({ expandedRows }) => (rangeToToggle) => {
        const expanded = fp.includes(rangeToToggle)(expandedRows)
        const updated = expanded ?
          fp.filter(
            (range) => range !== rangeToToggle
          )(expandedRows) :
          fp.concat([rangeToToggle])(expandedRows)
        return {
          expandedRows: updated
        }
      }
    }
  )
)(
  ({ user, snapshots, getReportRoute, expandedRows, toggleRow }) => {
    const rows = fp.map(
      ({ dateCreated, cpdCategorys, goals, snapshotId, cpdDay, cpdMonth, fromDate, toDate }) => {
        const snapshotDate = dateFnsCompat.format(dateCreated, dateFormats.ShortDateTime)
        const cpdPeriod = `${dateFnsCompat.format(dateFnsCompat.parse(fromDate), dateFormats.ShortDate)} - ${dateFnsCompat.format(dateFnsCompat.parse(toDate), dateFormats.ShortDate)}`
        return {
          options: {
            value: ''
          },
          cpdPeriod: {
            value: cpdPeriod
          },
          date: {
            value: snapshotDate
          },
          report: {
            value: <div>
              <LinkContainer className='no-padding' to={getReportRoute(snapshotId)}>
                <Button bsStyle='plain'>
                  View Report
              </Button>
              </LinkContainer>
            </div>
          }
        }
      }
    )(snapshots)
    const groupedRows = fp.flow(
      fp.groupBy('cpdPeriod.value')
    )(rows)
    const cpdRanges = fp.keys(groupedRows)
    const rowsToDisplay = fp.flatMap(
      (cpdRange) => {
        const rowsInRange = fp.flow(
          fp.get(cpdRange),
        )(groupedRows)
        const [first, ...rest] = rowsInRange
        if (fp.includes(cpdRange)(expandedRows)) {
          return [{
            ...first,
            options: {
              value: <div className='icon-green flexbox align-center'><FiChevronUp onClick={() => toggleRow(cpdRange)} /></div>
            }
          }].concat(rest)
        } else {
          return [{
            ...first,
            options: {
              value: <div className='icon-green flexbox align-center'><FiChevronDown onClick={() => toggleRow(cpdRange)} /></div>
            }
          }]
        }
      }
    )(cpdRanges)
    return <div>
      {
        rows.length > 0 && <GeneralTable rows={rowsToDisplay} columns={columns} />
      }
    </div>
  }
)


// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/partials/user-snapshot-table.js